import axios from "../../axios.js";

const changeDefaultCommission = async ({ commit }, data) => {
  const { commission } = data;
  const body = JSON.stringify({ commission });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`api/user/changeCommission`, body, config);
    commit("SET_COMMISSION", { message: res.data, value: commission });
  } catch (error) {
    commit("SET_COMMISSION", {
      message: "Nie udało się zaktualizować prowizji",
      value: null,
    });
  }
};

const getCurrentDefaultCommission = async ({ commit }) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get("api/user/commission", config);
    let commission = parseFloat(res.data.commission);
    if (isNaN(commission)) {
      // Backend bez poprawki .getValue() zwraca toString() całej encji parametru,
      // np. "Parameter(..., variable=COMMISSION, value=0.15)" - wyciągamy value= z tego stringa.
      const match = String(res.data.commission).match(/value=([0-9.]+)/);
      if (match) {
        commission = parseFloat(match[1]);
      }
    }
    if (!isNaN(commission)) {
      commit("GET_CURRENT_COMMISSION", commission);
    }
  } catch (error) {
    // Zostawiamy poprzednią wartość - wpisanie komunikatu błędu do default_commission
    // kończyło się wyświetlaniem "NaN %" wszędzie, gdzie używany jest getCurrentCommission.
    console.log(error);
  }
};

const changeUserCommission = async ({ commit }, data) => {
  const userId = data.userId;
  const commission = parseFloat(data.commission);
  const commission_valid_date = data.commission_valid_date
  try {
    await axios.post(`api/admin/user-commission/${userId}?commission=${commission}&commission_valid_date=${commission_valid_date}`,);
    commit("SET_USER_COMMISSION", "Pomyślnie zmieniono prowizję!");
  } catch (error) {
    commit("SET_USER_COMMISSION", "Nie udało się zmienić prowizji użytkownika");
  }
};

const downloadUserCommisionsXls = async ({ commit }) => {
  const url = "api/admin/user-commissions/file";
  axios(url, {
    method: "GET",
    headers: {
      "Content-Disposition": "attachment; filename=user profiles.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
  })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "user_commissions.xls");
      document.body.appendChild(fileLink);

      fileLink.click();
      commit("SET_DOWNLOAD_MESSAGE", "OK")
    })
    .catch((err) => console.log(err.response));


}

export default {
  changeDefaultCommission,
  getCurrentDefaultCommission,
  changeUserCommission,
  downloadUserCommisionsXls
};
